// removed by extract-text-webpack-plugin
module.exports = {"Ripple":"_m9BQw","ripple":"_1L2o4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.scss
// module id = 438
// module chunks = 0